module.exports = SharedDependencies.MobX['@local/application'];